import { OwaDate } from '../owaDate/owaDate';

/**
 * Adapter to pass OwaDate to properties that expect Date

 * This should only be used when bridging time-zone aware
 * OWA components with non-OWA components that only work
 * with JavaScript's Date object.
 *
 * Usage of this function must be extremely limited.
 */
export default (owaDate: OwaDate) => (owaDate as unknown) as Date;
